import type { IconData } from '@stacksjs/iconify-core'

export const mall: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M43 45H5V21.998C5 19.236 7.236 17 9.995 17.124c8.854.4 20.827 1.755 28.989 3.87c2.442.633 4.016 2.9 4.016 5.423zM5 33h38M3 45h42M17.5 33v12m13-12v12M34 13v6.5m-6.932-9.36c.096 1.462 1.154 2.58 2.614 2.704c1.02.087 2.426.156 4.318.156s3.298-.069 4.318-.156c1.46-.124 2.518-1.242 2.614-2.704c.04-.613.068-1.332.068-2.14s-.028-1.527-.068-2.14c-.096-1.462-1.154-2.58-2.614-2.704C37.298 3.069 35.892 3 34 3s-3.298.069-4.318.156c-1.46.124-2.518 1.242-2.614 2.704A33 33 0 0 0 27 8c0 .808.028 1.527.068 2.14\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mall
